import React from 'react'

const Copyright = () => {
  return (
    <footer className="text-center font-semibold mt-8 py-5">
        Copyright © 2023 Novelio Technologies Pvt. Ltd. 
    </footer>
  )
}

export default Copyright